import {
    Menu as ChakraMenu,
    MenuButton,
    MenuList,
    MenuItem,
    MenuDivider,
    Icon,
    Portal,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { MdOutlineLogout } from "react-icons/md";

import { AiOutlineUser } from "react-icons/ai";


const UserMenu = ({ userInfo, userMenuItems, handleCouponsClick, handleLogout }) => (
    <ChakraMenu>
        <MenuButton>
            <AiOutlineUser className="h-6 w-6 text-gray-500" />
        </MenuButton>
        <Portal>
            <MenuList zIndex="99" className="text-sm font-semibold text-black">
                {userInfo ? (
                    <>
                        {userMenuItems
                            .filter((item) => userInfo.isAdmin || item.userMenu)
                            .map((item) =>
                                item.name === "Coupons" ? (
                                    <MenuItem key={item.name} onClick={handleCouponsClick}>
                                        <Icon as={item.icon} w={5} h={5} mr={2} />
                                        {item.name}
                                    </MenuItem>
                                ) : (
                                    <MenuItem key={item.href} as={RouterLink} to={item.href}>
                                        <Icon as={item.icon} w={5} h={5} mr={2} />
                                        {item.name}
                                    </MenuItem>
                                )
                            )}
                        <MenuDivider />
                        <MenuItem onClick={handleLogout}>
                            <Icon as={MdOutlineLogout} w={5} h={5} mr={2} />
                            Logout
                        </MenuItem>
                    </>
                ) : (
                    <>
                        <MenuItem as={RouterLink} to="/signup">Sign In</MenuItem>
                        <MenuItem as={RouterLink} to="/registration">Create account</MenuItem>
                    </>
                )}
            </MenuList>
        </Portal>
    </ChakraMenu>
);


const IconLink = ({ icon: Icon, to, badgeCount }) => (
    <RouterLink to={to} className="relative text-black ml-2">
        <Icon className="h-6 w-6 text-gray-500" />
        {badgeCount > 0 && (
            <span className="absolute -top-2 left-4 bg-[#000080] text-white text-[10px] w-[18px] h-[18px] rounded-full flex items-center justify-center">
                {badgeCount}
            </span>
        )}
    </RouterLink>
);

export  { UserMenu, IconLink };
